export enum EMemberCenterErrorCode {
  SUCCESS = 0,
  VERIFICATION_CODE_EXPIRED = 2012,
  VERIFICATION_CODE_LOCKED = 2014,
}

/** 前端自訂的重寄驗證碼冷卻時間（ms）；後端目前沒有回傳可用的重寄解鎖時間戳 */
export const RESEND_VERIFICATION_CODE_COOLDOWN_MS = 60_000;
